import React from 'react';

/**
 * Sticky footer: how far through this document the reviewer is, and the two
 * moves available. Committing is blocked until every field is settled — the
 * server rejects an incomplete submission, so offering it would only fail.
 *
 * The two buttons are the canonical ResUI pills. The secondary is a REAL
 * secondary (white, brand border) — it was previously a bespoke class named
 * `-secondary` but painted with the light-grey tertiary surface, which design
 * spotted on a screenshot.
 *
 * "Cancel" returns to Dataset details, per design. It does NOT step back a
 * document: the file rail selects any document directly, so a Previous button
 * only duplicated it, and the frame's 117px secondary fits "Cancel", not
 * "Previous".
 */
const DocumentReviewFooter = ({
  settled,
  total,
  isLast,
  complete,
  onCancel,
  onCommit,
}) => (
  <div className="docreview-footer">
    <span className="docreview-progress">
      <strong>{settled} of {total}</strong> fields settled
    </span>
    <button
      type="button"
      className="resui-btn resui-btn--secondary"
      onClick={onCancel}
    >
      Cancel
    </button>
    <button
      type="button"
      className="resui-btn resui-btn--primary"
      disabled={!complete}
      title={complete ? undefined : 'Settle every field on this document to continue'}
      onClick={onCommit}
    >
      {/* "and", not "&" — design's platform-wide call. */}
      {isLast ? 'Save and finish' : 'Save and continue'}
    </button>
  </div>
);

export default DocumentReviewFooter;
